import React from 'react';
import PropTypes from 'prop-types';

import { useNavigate, useParams } from 'react-router-dom';

import Form from 'components/Admin/Prompts/Widget/Form';

import { Modal } from 'react-bootstrap';
import actions from 'components/Admin/Prompts/Actions/Actions';

import usePrompt from 'components/Admin/Prompts/Hooks/usePrompt';

import EmptyBlock from 'components/ui/EmptyBlock';

export default function Index({ refresh }) {
  const { id } = useParams();

  const navigate = useNavigate();

  const prompt = usePrompt({ id });

  const onSave = (values, onSuccess, onError) => {
    actions.update(id, values, () => {
      onSuccess();
      refresh();
      navigate('/admin/prompts');
    }, onError);
  };

  const onClose = () => {
    navigate('/admin/prompts');
  };

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Prompt</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        {prompt ? (
          <Form
            onSave={onSave}
            onClose={onClose}
            prompt={prompt.attributes}
          />
        ) : <EmptyBlock text="Loading..." />}

      </Modal.Body>
    </Modal>
  );
}

Index.propTypes = {
  refresh: PropTypes.func.isRequired,
};
